import React, { useState, useEffect } from 'react';
import styles from './Groups.module.css';
import { stages } from '../../data/studentsData';
import apiClient from '../../api/client';

const Groups = () => {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [formData, setFormData] = useState({ name: '', stage: '', time: '' });

  const fetchGroups = async () => {
    try {
      const { data } = await apiClient.get('/groups');
      setGroups(data);
    } catch (error) {
      console.error('❌ مشكلة في جلب المجموعات:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGroups();
  }, []);

  const handleAddGroup = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data: savedGroup } = await apiClient.post('/groups', formData);
      setGroups(prev => [...prev, savedGroup]);
      setFormData({ name: '', stage: '', time: '' });
    } catch (error) {
      const message = error.response?.data?.message || 'حصل خطأ أثناء إضافة المجموعة';
      alert(message);
    } finally {
      setSaving(false);
    }
  };

  const handleDeleteGroup = async (group) => {
    if (!window.confirm(`متأكد إنك عايز تحذف مجموعة "${group.name}"؟`)) return;
    try {
      await apiClient.delete(`/groups/${group._id}`);
      setGroups(prev => prev.filter(g => g._id !== group._id));
    } catch (error) {
      const message = error.response?.data?.message || 'حصل خطأ أثناء حذف المجموعة';
      alert(message);
    }
  };

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.header}>
        <h1 className={styles.title}>إدارة المجموعات</h1>
      </div>

      {/* فورم إضافة مجموعة جديدة */}
      <form className={styles.formCard} onSubmit={handleAddGroup}>
        <h2 className={styles.sectionTitle}>إضافة مجموعة جديدة</h2>
        <div className={styles.formGrid}>
          <div className={styles.formGroup}>
            <label>اسم المجموعة</label>
            <input
              type="text"
              className={styles.formInput}
              placeholder="مثال: مجموعة أ"
              required
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            />
          </div>

          <div className={styles.formGroup}>
            <label>المرحلة الدراسية</label>
            <select
              className={styles.formInput}
              required
              value={formData.stage}
              onChange={(e) => setFormData({ ...formData, stage: e.target.value })}
            >
              <option value="">اختر المرحلة</option>
              {stages.map((stage, index) => (
                <option key={index} value={stage}>{stage}</option>
              ))}
            </select>
          </div>

          <div className={styles.formGroup}>
            <label>الميعاد</label>
            <input
              type="text"
              className={styles.formInput}
              placeholder="مثال: السبت والثلاثاء 4:00 عصراً"
              value={formData.time}
              onChange={(e) => setFormData({ ...formData, time: e.target.value })}
            />
          </div>
        </div>

        <button type="submit" className={styles.saveBtn} disabled={saving}>
          {saving ? 'جاري الإضافة...' : '+ إضافة المجموعة'}
        </button>
      </form>

      {/* قائمة المجموعات الحالية */}
      <div className={styles.tableContainer}>
        <h2 className={styles.sectionTitle}>المجموعات الحالية</h2>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>اسم المجموعة</th>
              <th>المرحلة الدراسية</th>
              <th>الميعاد</th>
              <th>حذف</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="4" style={{ textAlign: 'center', color: '#6b7280' }}>جاري التحميل...</td>
              </tr>
            ) : groups.length > 0 ? (
              groups.map(group => (
                <tr key={group._id}>
                  <td>{group.name}</td>
                  <td>{group.stage}</td>
                  <td>{group.time || '—'}</td>
                  <td>
                    <button
                      type="button"
                      className={styles.deleteBtn}
                      onClick={() => handleDeleteGroup(group)}
                    >
                      🗑️ حذف
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" style={{ textAlign: 'center', color: '#6b7280' }}>
                  لسه مفيش مجموعات مضافة، أضف أول مجموعة من الفورم فوق
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Groups;
